import { atom } from 'jotai';
import { BulkOperationState } from '../typings/bulk-action-progress';

export const bulkActionProgressAtom = atom<BulkOperationState[]>([]);
